import script from "./DoctorListView.vue?vue&type=script&setup=true&lang=js"
export * from "./DoctorListView.vue?vue&type=script&setup=true&lang=js"

import "./DoctorListView.vue?vue&type=style&index=0&id=694ac3af&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-melindacvc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-694ac3af"]])

export default __exports__